export default {
  setSavedApplicationId(state, payload) {
    if (payload)
      window.localStorage.setItem('savedSellerApplicationId', payload);
    else window.localStorage.removeItem('savedSellerApplicationId');
    state.savedApplicationId = payload;
  },
  setId(state, payload) {
    state.id = payload;
  },
  setStep(state, { stepName, step }) {
    state[stepName] = step;
  },
  setStepIsCompleted(state, { stepName, step }) {
    state[stepName].isCompleted = step;
  },
  setApplication(state, payload) {
    const { id, currentStatus } = payload;
    const {
      intro,
      questions,
      companyInformation,
      contactInformation,
      contract,
    } = payload.steps;

    state.id = id;
    state.currentStatus = currentStatus;
    state.intro = intro;
    state.questions = questions;
    state.companyInformation = companyInformation;
    state.contactInformation = contactInformation;
    state.contract = contract;
  },
  resetApplication(state) {
    const {
      intro,
      questions,
      companyInformation,
      contactInformation,
      contract,
    } = state.defaultSteps;

    state.id = null;
    state.currentStatus = 'new';
    state.intro = intro;
    state.questions = questions;
    state.companyInformation = companyInformation;
    state.contactInformation = contactInformation;
    state.contract = contract;
  },
};
